export function GalleryIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33236 3.22607C2.87212 3.22607 2.49902 3.59917 2.49902 4.05941V13.3927C2.49902 13.853 2.87212 14.2261 3.33236 14.2261H12.6657C13.1259 14.2261 13.499 13.853 13.499 13.3927V4.05941C13.499 3.59917 13.1259 3.22607 12.6657 3.22607H3.33236ZM1.49902 4.05941C1.49902 3.04689 2.31983 2.22607 3.33236 2.22607H12.6657C13.6782 2.22607 14.499 3.04689 14.499 4.05941V13.3927C14.499 14.4053 13.6782 15.2261 12.6657 15.2261H3.33236C2.31983 15.2261 1.49902 14.4053 1.49902 13.3927V4.05941Z"
        fill="#101010"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66577 5.89258C5.38963 5.89258 5.16577 6.11644 5.16577 6.39258C5.16577 6.66872 5.38963 6.89258 5.66577 6.89258C5.94191 6.89258 6.16577 6.66872 6.16577 6.39258C6.16577 6.11644 5.94191 5.89258 5.66577 5.89258ZM4.16577 6.39258C4.16577 5.56415 4.83734 4.89258 5.66577 4.89258C6.4942 4.89258 7.16577 5.56415 7.16577 6.39258C7.16577 7.22101 6.4942 7.89258 5.66577 7.89258C4.83734 7.89258 4.16577 7.22101 4.16577 6.39258Z"
        fill="#101010"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3121 7.03902C10.5073 6.84376 10.8239 6.84376 11.0192 7.03902L14.3525 10.3724C14.5478 10.5676 14.5478 10.8842 14.3525 11.0795C14.1572 11.2747 13.8407 11.2747 13.6454 11.0795L10.6656 8.09968L3.68583 15.0795C3.49057 15.2747 3.17398 15.2747 2.97872 15.0795C2.78346 14.8842 2.78346 14.5676 2.97872 14.3724L10.3121 7.03902Z"
        fill="#101010"
      />
    </svg>
  )
}
